module.exports = __webpack_public_path__ + "static/media/cnNuevaEsperanza.ade0baa2.svg";